import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-upload-result',
  templateUrl: './upload-result.component.html',
  styleUrls: ['./upload-result.component.css']
})
export class UploadResultComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
